module.exports = "https://www.gc-qa.gnp.com.mx/d3d771012b02d511a137ab67c107a5a7.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/60.svg
// module id = 8044
// module chunks = 0